export default __webpack_public_path__ + "static/konyaspor-logo-d0bc0d0f427d2e920f80028260a9acd3.png";